function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CloseIcon from "static/svg/close.svg";
import { generateOnKeyDownHandler } from "/client/services/accessibility/accessibility-service";
import { StyledLiveBoardScreenComponent } from "./live-board-screen-component.scss";
import BoardViewsTab from "segments/desktop/core-components/board-views-tab/board-views-tab";
import TabComponent from "/components/core/tabs/tab/tab-component";
import Title from "segments/desktop/core-components/title/title";
import { tabs, MAIN_TABLE_TAB_ID } from "./live-board-consts";
import Banner from "segments/desktop/core-components/banner/banner";
import { BRAND_WORK_MANAGEMENT_PRIMARY_THEME_ID } from "segments/segments-service";
import Shake from "/components/enhancements/shake/shake-component";
import { useState } from "react";
import classnames from "classnames";
import SignupButton from "segments/desktop/core-components/button/signup-button/signup-button";
import { withGenericConfig } from "/contexts/generic-config-context";
import DefaultProps from "./default-props";
const liveBoardScreenComponent = (props)=>{
    const { translate, closeLiveBoard, showLiveBoard, embeddedBoardLink, boardBannerText, embeddedBoardTitle, addSecondLiveBoardSignUpButton, liveBoardToolTipText } = props;
    const [shakerIsActive, setIsActive] = useState(false);
    const [currentTab, setCurrentTab] = useState(MAIN_TABLE_TAB_ID);
    const LIVE_BOARD_BANNER_PLACEMENT = "live_board_banner_placement";
    const LIVE_BOARD_TOP_RIGHT_PLACEMENT = "live_board_top_right_placement";
    const LIVE_BOARD_TAB_LOCATION = "live_board_tab_placement";
    const TOOLTIP_DEFAULT_TEXT = "Start by adding a task";
    const startShaking = (callback)=>{
        setIsActive(true);
        callback();
    };
    const shakeBanner = ()=>{
        startShaking(resetShaker);
    };
    const resetShaker = ()=>{
        setTimeout(()=>setIsActive(false), 600);
    };
    const onTabClick = (index)=>{
        var _tabs_index;
        setCurrentTab((_tabs_index = tabs[index]) === null || _tabs_index === void 0 ? void 0 : _tabs_index.tabID);
    };
    const onKeyDown = generateOnKeyDownHandler(closeLiveBoard);
    const renderCloseIcon = ()=>{
        return /*#__PURE__*/ _jsx("div", {
            className: "live-board-close",
            onClick: closeLiveBoard,
            onKeyDown: onKeyDown,
            tabIndex: 0,
            role: "button",
            "aria-label": translate("liveBoard.close"),
            children: /*#__PURE__*/ _jsx(CloseIcon, {
                className: "close-icon"
            })
        });
    };
    const tabsRenderer = ()=>{
        const { theme } = props;
        return tabs === null || tabs === void 0 ? void 0 : tabs.map((tab, index)=>{
            const { tabLabel, hideLabel, image, liveBoardTabComponent: LiveBoardTabComponent, scrollVisible, componentProps } = tab;
            return /*#__PURE__*/ _jsx(TabComponent, {
                label: tabLabel,
                color: theme,
                useXSMLabels: true,
                tabIcon: image,
                tabsWithIcons: true,
                hideLabel: hideLabel,
                extraData: {
                    location: LIVE_BOARD_TAB_LOCATION
                },
                children: /*#__PURE__*/ _jsx("div", {
                    className: classnames("tab-component", {
                        "scroll-visible": scrollVisible
                    }),
                    children: /*#__PURE__*/ _jsx(LiveBoardTabComponent, _object_spread_props(_object_spread({
                        onCardClick: shakeBanner
                    }, componentProps), {
                        sharableLink: embeddedBoardLink,
                        tooltipText: liveBoardToolTipText || TOOLTIP_DEFAULT_TEXT
                    }))
                })
            }, index);
        });
    };
    return /*#__PURE__*/ _jsxs(StyledLiveBoardScreenComponent, {
        className: classnames("live-board-screen", {
            "board-fully-visible": showLiveBoard
        }),
        children: [
            showLiveBoard && renderCloseIcon(),
            /*#__PURE__*/ _jsx("div", {
                className: "live-board-content-wrapper",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "right-section",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "banner-wrapper",
                            children: /*#__PURE__*/ _jsx(Shake, {
                                isActive: shakerIsActive,
                                children: /*#__PURE__*/ _jsx(Banner, {
                                    buttonConfig: {
                                        buttonType: "Signup"
                                    },
                                    bannerCta: translate("signup.cta"),
                                    bannerText: boardBannerText,
                                    withCloseIcon: false,
                                    theme: BRAND_WORK_MANAGEMENT_PRIMARY_THEME_ID,
                                    hideBanner: false,
                                    placement: LIVE_BOARD_BANNER_PLACEMENT,
                                    extraData: {
                                        live_board_tab_type: currentTab
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "board-title-wrapper",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "title-content",
                                    children: [
                                        /*#__PURE__*/ _jsx(Title, {
                                            title: embeddedBoardTitle
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "tag",
                                            children: translate("liveBoard.demoEnvironment")
                                        })
                                    ]
                                }),
                                addSecondLiveBoardSignUpButton && /*#__PURE__*/ _jsx("div", {
                                    className: "sign-up-button-wrapper",
                                    children: /*#__PURE__*/ _jsx(SignupButton, {
                                        extraData: {
                                            placement: LIVE_BOARD_TOP_RIGHT_PLACEMENT
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(BoardViewsTab, {
                            fullSizeContent: true,
                            tabsRenderer: tabsRenderer,
                            onTabClick: onTabClick
                        })
                    ]
                })
            })
        ]
    });
};
liveBoardScreenComponent.defaultProps = DefaultProps;
export default withGenericConfig(liveBoardScreenComponent);
